export default __webpack_public_path__ + "static/media/videoResourceIcon.68e94c5b.svg";